import { Type } from "class-transformer";
import { IsDate, IsString } from "class-validator";
import { AbstractJSONModel } from "./master-model";

export class Holiday extends AbstractJSONModel {
  @IsDate()
  @Type(() => Date)
  public date: Date = new Date();
  @IsString()
  public name = "";

  equals(other: Holiday): boolean {
    return other.date === this.date;
  }
}
